export default "__VITE_ASSET__yp2ilGL9__"